import { BG_ICON_COLOR, LIGHT_GREY } from "constants/index";

import type { Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";

// Shared styling for the white call-to-action button used across banner steps.
// Typed as a plain style object rather than the wider SxProps union so other
// banners can build on it without losing the ability to compose.
export const BANNER_CTA_BUTTON_SX: SystemStyleObject<Theme> = {
  backgroundColor: "white",
  color: BG_ICON_COLOR,
  fontWeight: "bold",
  "&:hover": { backgroundColor: LIGHT_GREY },
};

// Hide a banner's descriptive text below this width so the long copy never
// collides with the company name the toolbar renders to its left; only the
// compact CTA remains on narrower viewports.
//
// Set to the MUI `xl` breakpoint because the banner strings are all 40-60
// characters and the toolbar only gives its middle section enough room for one
// line of that from ~1500px up. At the previous 1200px they still wrapped onto
// two lines and the second line ran into the company name.
export const BANNER_TEXT_MIN_WIDTH = "(min-width:1536px)";
